<template>
  <div v-if="$vuetify.breakpoint.smAndDown">
    <v-app-bar app dark dense :extension-height="20" :color="bar.color" clipped-left>
      <v-img
        :src="bar.logo"
        height=45
        @click="$router.replace('/')"
        contain style="margin-top: 69px; margin-left: -50px; cursor:pointer !important;">
      </v-img>
      <v-spacer></v-spacer>
      <LanguageSelector></LanguageSelector>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      clipped app
    >
      <v-list
        nav
      >
        <v-list-item-group>
          <v-list-item v-for="item in buttons" :key="item.id" link @click="$router.replace(item.href)">
            <v-list-item-content>
              <v-list-item-title class="title font-weight-bold">{{item.label}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
  <v-app-bar v-else app dark dense :extension-height="20" :color="bar.color">
    <v-img
      :src="bar.logo"
      height=60
      @click="$router.replace('/')"
      contain style="margin-top: 75px; margin-left: -160px; cursor:pointer  !important;">
    </v-img>
    <v-spacer></v-spacer>
    <LanguageSelector></LanguageSelector>

    <v-btn
      v-for="item in buttons"
      text
      :key="item.id"
      @click="$router.replace(item.href)"
    >
      <span class="ml--1 font-weight-light menu-item-font">{{item.label}}</span>
    </v-btn>
  </v-app-bar>
</template>

<script>
  import LanguageSelector from './LanguageSelector.vue'

  export default {
    components: { LanguageSelector },
    data: () => ({
      drawer: false,
      bar: {
        color: "#3D3D3D",
        logo: require('../assets/reddle_title.png')
      },
      group: null
    }),
    watch: {
      group() {
        this.drawer = false
      },
    },
    computed: {
      buttons: function () {
        return [
          {
            label: this.$t('Home'),
            id: '1',
            href: '/',
            icon: 'house'
          },
          {
            label: this.$t('impress'),
            id: '2',
            href: '/impressum'
            ,
            icon: 'home'
          },
          {
            label: this.$t('privacy'),
            id: '3',
            href: '/privacy',
            icon: 'home'
          },
          {
            label: this.$t('contact'),
            id: '4',
            href: '/contact',
            icon: 'home'
          },
          {
            label: this.$t('register'),
            id: '5',
            href: '/hello',
            icon: 'home'
          }
        ]
      }
    }
  };
</script>
